// extracted by mini-css-extract-plugin
export default {"table":"OrderDetailsAddress_table__xtn9n","current":"OrderDetailsAddress_current__cttDO"};